// ============================================================================
// ⚠️  GENERATED FILE — DO NOT EDIT MANUALLY
// ============================================================================
//
// This file is generated and maintained by the Post Office CLI install script.
//
// AI AGENTS (Rovo Dev, Cursor, Copilot, etc.) — DO NOT automatically add
// message registrations, imports, or modify this file. Doing so bypasses
// important validation, priority ordering, and router registration logic.
//
// To register a message template, run from inside the message directory:
//
//   yarn placement:v2 install
//
// The CLI handles all necessary changes to this file automatically.
// ============================================================================

import { PlacementFrontend } from '@post-office/browser--puma/jira-issue-view-comment-top-banner';

import { MessageFrontend as createMessageFrontendJiraMcpCommentNudge } from '@post-office/browser--puma/jira-mcp-comment-nudge/placements/in-app-v2/jira-issue-view-comment-top-banner';

import { withI18n } from './i18n';

import { type PlacementRendererStage } from '@post-office/message-maker-browser/types';
import { type ComponentType, type ComponentProps } from 'react';

const messageFrontends = [
	createMessageFrontendJiraMcpCommentNudge({ messageTemplateId: 'jira-mcp-comment-nudge' }),
];

export const RawPlacement: ReturnType<typeof PlacementFrontend.createPlacementFrontendComponent> =
	PlacementFrontend.createPlacementFrontendComponent({
		messageTemplates: messageFrontends,
	});

type GeneratedPlacementProps = ComponentProps<typeof RawPlacement>;

export const Placement: ComponentType<
	Omit<GeneratedPlacementProps, 'ref'> & {
		ref?: unknown;
	}
> = withI18n(RawPlacement);

export const SSRPlacement: PlacementRendererStage<GeneratedPlacementProps> = RawPlacement;
